module.exports = "pegasus/assets/themelp1/product/102.png";